/** The app's one date format: `12-Aug-2026`. Unambiguous for Indian users, who read both D/M and M/D. */
export function formatDate(iso: string): string {
  // en-GB gives "12 Aug 2026"; the separator swap is the whole trick. Intl can emit
  // non-breaking spaces, hence \s rather than a literal space.
  return new Date(iso)
    .toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
    .replace(/\s+/g, '-')
}

/** Same date plus the clock time: `12-Aug-2026, 3:45 pm`. */
export function formatDateTime(iso: string): string {
  const time = new Date(iso).toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit' })
  return `${formatDate(iso)}, ${time}`
}
